export const ENROLL_PASSKEY_MODAL_ID = 'enroll-passkey-modal';

export const PASSKEY_NICKNAME_LABEL = 'Name this passkey (optional)';

export const PASSKEY_NICKNAME_PLACEHOLDER = 'e.g. My MacBook';

export const PASSKEY_NICKNAME_MAX_LENGTH = 100;

export const PASSKEY_ALREADY_EXISTS_MESSAGE =
  'This account already has a passkey on this device. To add another, first remove the existing one from your passkey list.';

export const PASSKEY_CANCELED_MESSAGE =
  'Passkey setup was canceled or timed out. Please try again.';

export const PASSKEY_GENERIC_ERROR_MESSAGE =
  'Could not set up the passkey. Make sure your device supports it, then try again.';
